module.exports = __webpack_public_path__ + "img/icon-tag_w.7fe9e84.svg";